import React from 'react';
import PrefetchIssues from '@atlassian/jira-providers-issue/src/components/prefetch/index.tsx';
import { useBacklogSelector } from '../../state/index.tsx';
import { getCardIds } from '../../state/selectors/cards/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const issueIds = useBacklogSelector((state) => getCardIds(state).map((cardId) => String(cardId)));
	return <PrefetchIssues issueIds={issueIds} />;
};
